import axios from 'axios';
import '../../assets/css/components/program.css';
import { PromotionsTable } from '../../components/PromotionsComponents';
import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { useSearchParams } from 'react-router-dom';
import { InitiateTutorial } from '../../components/Onboarding';

export default function Promotions() {
  const {handleSignOut, getJwtToken} = useContext(AuthContext);
  const [promotions, setPromotions] = useState(false);
  const [pageInfo, setPageInfo] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [tutorial, setTutorial] = useState(0);
  
  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        const token = await getJwtToken();
        const tutorial = searchParams.get('tutorial');
        if (tutorial === 'true') setTutorial(1);
        const res = await axios.get('https://api.amplifyloyalty.com/app/stores/promotions', {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.name === 'BadRequestError') {
          handleSignOut();
        } else {
          let info = {...res.data}
          delete info.data;
          setPageInfo(info || {
            hasNextPage: false,
            hasPrevPage: false,
            limit: 10,
            nextPage: null,
            page: 1,
            pagingCounter: 1,
            prevPage: null,
            totalDocs: 0,
            totalPages: 1
          });
          setPromotions(res.data.data || []);
        }
      } catch (err) {
        console.log(err.response);
      }
    };
    fetchPromotions();
  },[])

  return (
    <div className="main">
      {tutorial === 1 && 
        <InitiateTutorial 
          text="In this guide, you will learn how to create new Promotions and customize
            them to dynamically update Shopify sections on your store."
          header="Running Promotions" 
          setTutorial={setTutorial}
        />
      }
      <PromotionsTable 
        promotions={promotions} 
        setPromotions={setPromotions} 
        pageInfo={pageInfo} 
        setPageInfo={setPageInfo}
        tutorial={tutorial}
        setTutorial={setTutorial}
        getJwtToken={getJwtToken}
      />
    </div>
  )
}